module.exports = __webpack_public_path__ + "static/media/1.7d0b0315.jpg";